function initSwiper(slider) {
  const sliderOptions = {
    slidesPerView: 5,
    spaceBetween: 10,
    autoplay: {
      delay: 200,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: slider.querySelector('[data-swiper-button-next]'),
      prevEl: slider.querySelector('[data-swiper-button-prev]'),
    },
    breakpoints: {
      280: {
        slidesPerView: 4.5,
      },
      360: {
        slidesPerView: 4.5,
      },
      420: {
        slidesPerView: 5.5,
      },
      480: {
        slidesPerView: 4.5,
      },
      769: {
        slidesPerView: 5,
        spaceBetween: 10,
      }
    },
    on: {
      init(swiper) {
        const slides = swiper.el.querySelectorAll('[data-swatches-slide]');

        const currentBreakpoint = swiper.currentBreakpoint || Object.keys(swiper.params.breakpoints).pop();
        const slidesPerView = swiper.params.breakpoints[currentBreakpoint]?.slidesPerView || swiper.params.slidesPerView;
        let slidesToCompare;
        if (slidesPerView === 'auto') {
          slidesToCompare = 5;
        } else {
          slidesToCompare = slidesPerView;
        }
        if (slides.length > slidesToCompare) {
          swiper.el.classList.add("product-card__swatches--padding");
          swiper.el.parentElement.classList.add("product-card__swatches--style");
        } else {
          slides.forEach(element => {
            element.style.width = "max-content";
            element.style.margin = 0;
          });
        }
        if (slides.length == 0) {
          swiper.el.parentElement.classList.add('visually-hidden');
        }
        setTimeout(() => { 
          if (swiper.autoplay && swiper.autoplay.stop) {
            swiper.autoplay.stop();
          }
          if (swiper.slideTo) {
            swiper.slideTo(0, 0);
          }
        }, 500);
      }
    },
  };
  new Swiper(slider, sliderOptions);
}

document.querySelectorAll('[data-swatches-slider]').forEach(slider => {
  initSwiper(slider);
});
